import React, {useEffect,useState} from 'react';
import { Link } from 'react-router-dom';
import ReactDOM  from 'react-dom';
import ViewBag  from './ViewBag';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../Context/AuthContext'
import { createRoot } from 'react-dom/client';

export default function Header({}) {
  const {authUser, isAuthenticated, isLoggedIn, countItems, UpdateBagCount ,setAuthUser ,setIsLoggedIn } =useAuth();
  //const [UID, setUserID] = useState('');
  const [itemsInBag, setItemsInBag]=useState(0);
  const [userData, setUserData] = useState(null);

  useEffect(()=>{
    isAuthenticated();    
  }, [])

useEffect(()=>{
  //console.log("User:\n",authUser);  
  setUserData(authUser);
  //UpdateBagCount();  
}, [authUser,isLoggedIn,countItems])

useEffect(() => {
  if (authUser.AccountType === "admin") {
      hideShowLinkDivs();
  }
  else{
    ShowLinkDivs();
  }
}, [authUser]);

function hideShowLinkDivs() {
  const showLinkDivs = document.querySelectorAll('.showLink');
  showLinkDivs.forEach(div => {
      div.style.display = 'none';
  });
};

function ShowLinkDivs() {
  const showLinkDivs = document.querySelectorAll('.showLink');
  showLinkDivs.forEach(div => {
      div.style.display = 'block';
  });
};


  useEffect(() => {   
    setItemsInBag(countItems);    
  },[countItems,authUser]);


  const navigate = useNavigate();  

  const handleCheckoutNavigation = () => {
      document.getElementById('viewBagDiv').remove();
      navigate('/Checkout');
  };


  const toggleSidebar = (event) => {    
    const Id = event.currentTarget.id;

    if (Id != null) { 
      if (document.getElementById('viewBagDiv')) {
        document.getElementById('viewBagDiv').remove();
      }
      const viewBagDiv = document.createElement("div");
      viewBagDiv.id = 'viewBagDiv';
      document.body.appendChild(viewBagDiv);

      const existingViewBag = document.getElementById('cart-sidebar');
      if (existingViewBag) {
        existingViewBag.remove();
      }

      createRoot(viewBagDiv).render(<ViewBag authUserID={authUser.ID} handleBagCount={UpdateBagCount} handleCheckoutNavigation={handleCheckoutNavigation} />);
    } else {
      console.log("toggleClickEvent, id: null");
    }
  };

  const goToProfile=()=>{
    if(isLoggedIn){
      navigate("/Profile");
    }
  }




  return (
    <>

    <header id="Header">
      <div>
        <Link to="/">
          <img src="assets/imgs/bywaldo-logo.png" alt="ByWaldo Logo" />
        </Link>
      </div>
      <div id="nav-bar" className="navigation">
        <div id="navigation" className="navigation">
          <div><Link to="/Magazine">ABOUT</Link></div>
          <div className='showLink'><Link to="/Catalog">CATALOG</Link></div>
          <div className='showLink'><Link to="/Booking">BOOKING</Link></div>
          <div>
            { 
              isLoggedIn 
              ? ( <Link to="/Profile"> {(authUser.FName.trimEnd()+' '+authUser.LName.trimEnd().substring(0, 1)).toUpperCase()} </Link>) 
              : (<Link to="/Login"> LOGIN</Link>)
            }           
          </div>         
          <div className='showLink'>
            <button className="border-0 bg-none">
              BAG<span id="bagCount">[{itemsInBag}]</span>
            </button>
          </div>
        </div>
        <div id="nav-toggle" onClick={showNav}>
          <hr className="nav-line" />
          <hr className="nav-line" />
          <hr className="nav-line" />
        </div>
      </div>
    </header>

   {/* {selectedSection === 'bag' &&  j} */}
   </>
  );
}


function showNav() {
  const navbar = document.getElementById('nav-bar');
  const navigation = document.getElementById('navigation');
  const navtoggle = document.getElementById('nav-toggle');

  if (navbar.classList.contains('navigation')) {
    navbar.classList.replace('navigation', 'open-nav');
    navigation.style.display = 'block';
    navtoggle.style.transform = 'rotate(90deg)';
    navtoggle.style.width = '1rem';
  } else {
    navbar.classList.replace('open-nav', 'navigation');
    navigation.style.display = 'none';
    navtoggle.style.transform = 'rotate(0deg)';
    navtoggle.style.width = '2rem';
  }
}
